<template>
  <div class="drainage-tool">
    <MobileSidebarWrapper id="drainages" param="id">
      <template slot="sidebar">
        <div class="sidebar-drainages">
          <div class="sidebar-header">
            <h1>{{ $ml.get("Drainage") }}</h1>
            <app-btn
              v-if="$store.getters['user/plan'] != 'impact'"
              class="add-fert"
              @click="$router.push('/dashboard/drainage/new')"
            >
              {{ $ml.get(`add`) }}
            </app-btn>
          </div>

          <aside :class="{ loading: loading }">
            <div>
              <div class="search-drainages">
                <SearchInput :secDelay="1" :delayed="true" @input="setSearch" />
              </div>
              <LoadingSVG
                v-if="loading"
                style="margin: 0 auto; display: block;"
              />
              <div class="drainages-list" v-if="drainages.length && !loading">
                <nav>
                  <SelectorOverlayContainer
                    :react-on="drainages"
                    :value="$route.params.id"
                  >
                    <SelectorOverlayItem
                      v-for="item in drainages"
                      :key="item.drainageId"
                      :class="{
                        is_active: item.drainageId == $route.params.id,
                      }"
                    >
                      <router-link
                        class="list-item"
                        :to="`/dashboard/drainage/${item.drainageId}`"
                      >
                        <div
                          class="--selector-overlay-pointer"
                          :class="{
                            'router-link-active':
                              item.drainageId == $route.params.id,
                          }"
                        >
                          <span class="">{{ item.name }}</span>
                        </div>
                      </router-link>
                    </SelectorOverlayItem>
                  </SelectorOverlayContainer>
                </nav>
              </div>

              <div class="empty-list" v-if="!drainages.length && !loading">
                {{
                  $ml.get("This list is empty. You can add your first drainage")
                }}
              </div>
            </div>
          </aside>
        </div>
      </template>

      <template slot="content">
        <router-view></router-view>
      </template>
    </MobileSidebarWrapper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingSVG from "@/components/ui/LoadingSVG";
import SearchInput from "@/components/common/SearchInput";
import MobileSidebarWrapper from "@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper";
import {
  SelectorOverlayContainer,
  SelectorOverlayItem,
} from "@/components/common/selector-overlay";

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    SelectorOverlayContainer,
    SelectorOverlayItem,
    MobileSidebarWrapper,
    LoadingSVG,
    SearchInput,
  },
  computed: {
    ...mapGetters({
      drainages: "drainage/drainages",
      drainageLoad: "drainage/drainageLoad",
    }),
  },
  created() {
    this.$store.dispatch("user-crops/updateData");
    this.sync();
  },
  methods: {
    //=================================================================================
    sync() {
      this.$store
        .dispatch("drainage/getUserDrainages")
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notices",
            title: this.$ml.get(
              `Please buy a plan before searching drainages.`
            ),
            type: "error",
          });
          this.loading = false;
        });
    },
    //=================================================================================
    setSearch(val) {
      console.log(val);
      this.$store.commit("drainage/setSearch", val);
      this.sync();
    },
  },
};
</script>

<style lang="scss" scoped>
.drainage-tool {
  display: flex;
  flex-direction: row;
  padding: 8px;
  .sidebar-drainages {
    width: 320px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .sidebar-header {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-bottom: 10px;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 70px;
      h1 {
        color: #333333;
        font-size: 26px;
        line-height: 100%;
        font-weight: bold;
      }
    }
    aside {
      border: 1px solid #e4e5e6;
      @media (max-width: 768px) {
        height: auto;
      }

      &.loading {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .empty-list {
        color: #4d4d4d;
        font-size: 15px;
        text-align: center;
        margin-top: 12px;
      }
      .search-drainages {
        margin-bottom: 20px;
      }
      .drainages-list {
        height: calc(100vh - 245px);
        overflow-y: auto;
        scrollbar-width: thin;
        a.list-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          position: relative;

          padding: 5px 0;
          border-top: 1px solid rgba(76, 80, 86, 0.1);

          > div {
            width: 100%;
            padding: 8px 20px;
            color: #4c5056;
            font-size: 18px;
            font-weight: 500;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            transition: color 0.5s ease;

            &.router-link-active {
              // background-color: $mainGreen;
              color: #fff;
              span.sub {
                color: #fff;
              }
            }
            span.sub {
              font-size: 12px;
              color: #8b8d91;
              text-transform: uppercase;
              padding-top: 6px;
            }
          }
        }
      }
    }
  }

  .loading-svg {
    width: 30px;
  }
}

.drainage-load {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
